// Sign in for Lead from Sharpspring API, This is first step of Application //
After Submit Login, Three conditions check // 1. If attorney already found in MS
DB, give already registered error // 2. If attorney not found in Lead API, give
attorney not found error, // 3. If attorney found in lead API and not already
registered, successfully login and redirect to Submit Application Form
<template>
  <div class="flex items-center min-h-screen w-full">
    <div
      class="w-full bg-white rounded shadow-lg p-8 m-4 md:max-w-sm md:mx-auto"
    >
      <div class="md:flex w-full">
        <div class="w-full py-10 px-5">
          <div class="flex items-center">
            <svg
              class="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
              ></path>
            </svg>
            <div class="text-right text-xl cobalt-text-color">
              Join Our Attorney Network
            </div>
          </div>
          <form class="mt-8 space-y-6" @submit.prevent="signIn" novalidate>
            <div class="rounded-sm">
              <div class="flex flex-col">
                <text-input
                id="email"
                  label="Enter Email Address"
                  :class="{ 'border-red-400': v$.form.email.$error }"
                  v-bind:value="form.email"
                  v-on:keyup="form.email = $event.target['value']"
                ></text-input>
                <div
                  class="text-red-600 mt-1 text-sm"
                  v-for="(error, index) in v$.form.email.$errors"
                  :key="index"
                >
                  <div v-if="error.$validator == 'required'">
                    {{ error.$message }}
                  </div>
                  <div v-if="error.$validator == 'email'">
                    Please enter valid email
                  </div>
                </div>
                <p class="text-xs">
                  Please use the email address that this application was sent
                  to.
                </p>
              </div>
            </div>

            <div>
              <button
                id="signin"
                type="submit"
                class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white cobalt-button-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-50"
                aria-required="true"
              >
                <span class="absolute left-0 inset-y-0 flex items-center pl-1">
                  <svg
                    class="w-6 h-6 "
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                    ></path>
                  </svg>
                </span>
                Click to proceed to the application
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextInput from "../Layout/Form/TextInput.vue";
// import { mapState } from "vuex";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { helpers } from "vuelidate/lib/validators";
const email = helpers.regex(
  "email",
  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}$/
);
export default {
  name: "SignIn",
  components: {
    TextInput,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data: function() {
    return {
      form: {},
    };
  },
  validations: {
    form: {
      email: {
        required,
        email,
      },
    },
  },
  created() {
    this.$store.watch(
      () => this.$store.state.leadData,
      (value) => {
        if (value.length != 0) {
          if (value.result.no_rec > 0) {
            localStorage.removeItem("leadData");
            this.$store.dispatch("logout");
            this.$toast.error("Attorney already registered");
          } else {
            localStorage.setItem("leadData", JSON.stringify(value));
            this.$router.push("/application");
          }
        }
      }
    );
    this.$store.watch(
      () => this.$store.state.errors,
      (value) => {
        if (value.length != 0) {
          this.$toast.error("Email not found");
        }
      }
    );
  },
  methods: {
    signIn: function() {
      this.v$.form.$touch(this.v$.form.errors);
      if (this.v$.form.$pending || this.v$.form.$error) return;
      this.$store.dispatch("loadLeadData", this.form.email);
    },
  },
};
</script>
